import { useGetDossierOverzicht } from "@/entities/dossier-overzicht";
import { getReikwijdteLabel } from "@/features/dossier-details";
import { useDossierPinStore } from "@/features/dossier-management";
import { ErrorDisplay } from "@/shared/components/error";
import { DossierCard } from "./dossier-card.tsx";
import { SkeletonDossierCard } from "./ui";

export function DossierList() {
    const { data: dossiers, isLoading, error } = useGetDossierOverzicht();
    const pinnedDossierIds = useDossierPinStore((s) => s.pinnedDossierIds);
    const orderedDossiers = dossiers
        ? [...dossiers].sort((a, b) => Number(pinnedDossierIds.includes(b.dossierId)) - Number(pinnedDossierIds.includes(a.dossierId)))
        : dossiers;

    return (
        <ol className="gap-s relative flex flex-row overflow-x-auto overflow-y-hidden py-3" data-testid="dossiers-list">
            {isLoading && <SkeletonDossierCard testId="sein-dossier-skeleton" />}
            {error && <ErrorDisplay error={error} onRetry={() => window.location.reload()} title="Fout bij het laden van dossiers" />}
            {orderedDossiers?.map((dossier) => (
                <DossierCard
                    key={dossier.dossierId}
                    dossierId={dossier.dossierId.toString()}
                    seinStartDatum={dossier.startDatumTijd}
                    omschrijving={dossier.omschrijving}
                    reikwijdteLabel={getReikwijdteLabel(dossier.reikwijdte, dossier.stations, dossier.trajecten)}
                    uitgezetteDiensten={dossier.uitgezetteDiensten}
                    acties={dossier.acties}
                    suggesties={dossier.suggesties}
                    betrokkenTreinen={dossier.betrokkenTreinen}
                    isPinned={pinnedDossierIds.includes(dossier.dossierId)}
                />
            ))}
        </ol>
    );
}
